/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import { MiFormData } from '@/components/MiForm/MiForm';
import { Model } from '@/models/Model';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { MiButtonOptions } from '@/components/MiButton/MiButton';
import { MiFormField } from '@/components/MiForm/MiForm';
import { MiDialogOptions } from '@/components/MiDialog/MiDialog';
import { User } from '@/models/User';

@Component<ForgotPassword>({})
export default class ForgotPassword extends Vue {
  protected passwordReset = false;

  protected token: string | null = null;

  protected email: string | null = null;

  protected password = '';

  protected password_confirmation = '';

  protected showExplanation = true;
  protected qrImage = '';

  protected payload = {
    secret: '',
    token1: '',
    token2: '',
  };

  protected mounted(): void {
    this.fetchQRCode();
  }

  protected fetchQRCode() {
    if (!this.user) return
    new User()
    .getQR(this.user.uuid)
    .then((response: any) => {
      this.qrImage = response.qr_image;
      this.payload.secret = response.secret;
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected logout() {
    this.$store.dispatch('userDeauthenticated');
    this.$router.push('/');
  }

  protected handleFieldChanged(field: MiFormField) {
    (this.payload as any)[field.key] = field.value;
  }

  protected createMfa() {
    const payload = {
      secret: this.payload.secret,
      token1: this.payload.token1,
      token2: this.payload.token2,
    }

    this.user
      .storeQr(payload, this.user.uuid)
      .then(() => {
        new User().current().then((user: User) => {
          this.$store.dispatch('userAuthenticated', user);
          this.$router.push('/dashboard');
        })
      })
      .catch((error: AxiosError) => {
        this.payload.token1 = '';
        this.payload.token2 = '';
        ErrorHandler.network(error);
      });
  }

  protected get title(): string {
    return this.passwordReset
      ? 'Wachtwoord aangepast!'
      : 'Wachwoord resetten';
  }

  protected get text(): string {
    return this.passwordReset
      ? 'Je wachtwoord is aangepast, je kunt nu inloggen met je nieuwe wachtwoord.'
      : 'Vul hieronder je een nieuw wacthwoord in';
  }

  protected get resetErrorDialog(): MiDialogOptions {
    return {
      title: 'Wachtwoord niet aangepast',
      text: 'We konden je wachtwoord niet aanpassen. Probeer het nogmaals via de link in de e-mail, of vraag een nieuwe wachtwoord reset aan.',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Sluiten',
          action: () => {
            this.$store.dispatch('closeDialog');
          },
        },
      },
    };
  }

  protected get buttonOptions(): MiButtonOptions {
    return {
      color: 'secondary',
      colorIntensity: 700,
      round: true,
      flat: true,
      label: 'terug naar Login',
      to: '/login'
    };
  }

  protected get user(): User {
    return this.$store.state.Auth;
  }

  protected get canSubmit() {
    return !!this.payload.token1 && !!this.payload.token2;
  }
}
